// Compiler result to JSON file
    import { createComponent } from 'js/declViewModelService';
    import { registerDynImportEntry } from 'js/moduleLoader';
    import AwParseService from 'js/awParseService';
    import AwFilterService from 'js/awFilterService';
    import { getField } from 'js/utils';
    import { Fragment } from 'react';
    let filterSer = AwFilterService.instance;
    import AwPanelSection from 'viewmodel/AwPanelSectionViewModel';
import AwWidget from 'viewmodel/AwWidgetViewModel';
    

    

    /*
    ctx imports
    */
    
    const ctxImportObj = {  };
    

    /*
    dynamic import
    */
    registerDynImportEntry('js/accHttpService', () => import('js/accHttpService'));
registerDynImportEntry('js/desUpdateLibraryService', () => import('js/desUpdateLibraryService'));
registerDynImportEntry('js/accEventBus', () => import('js/accEventBus'));;

    /*
    view model
    */
    const declViewModelJson = {
    "schemaVersion": "1.0.0",
    "imports": [],
    "data": {
        "name": {
            "displayName": "{{i18n.nameDisplayName}}",
            "type": "STRING",
            "isEditable": "false",
            "dbValue": "",
            "dispValue": ""
        },
        "description": {
            "displayName": "{{i18n.descriptionDisplayName}}",
            "type": "STRING",
            "isEditable": "false",
            "dbValue": "",
            "dispValue": "",
            "numberOfLines": 3
        }
    },
    "lifecycleHooks": {
        "onMount": "getLibraryDetails"
    },
    "props": {
        "accsessionid": {
            "type": "string"
        },
        "libraryid": {
            "type": "string"
        },
        "collaborationspaceid": {
            "type": "string"
        }
    },
    "actions": {
        "getLibraryDetails": {
            "actionType": "JSFunctionAsync",
            "method": "createHttpRequest",
            "inputData": {
                "request": {
                    "method": "POST",
                    "url": "/acc/orchestrate",
                    "withCredentials": true,
                    "data": {
                        "additionalProperties": {
                            "collaborationSpaceId": "{{props.collaborationspaceid}}"
                        },
                        "query": "query getLibrary( $libraryId: String) {getLibrary( libraryId: $libraryId) }",
                        "variables": {
                            "libraryId": "{{props.libraryid}}"
                        }
                    }
                },
                "progressIndicatorPrefix": "catalog",
                "accsessionid": "{{props.accsessionid}}"
            },
            "outputData": {
                "libraryDetailsObtained": "data.data.getLibrary.libraryObjs[0]"
            },
            "events": {
                "failure": [
                    {
                        "name": "getLibraryFailure",
                        "eventData": {
                            "eventData": "{{libraryDetailsObtained}}"
                        }
                    }
                ],
                "success": [
                    {
                        "name": "getLibrarySuccess",
                        "eventData": {
                            "eventData": "{{libraryDetailsObtained}}"
                        }
                    }
                ]
            },
            "deps": "js/accHttpService"
        },
        "updateSelectedLibraryDetails": {
            "actionType": "JSFunction",
            "method": "getSelectedLibraryDetails",
            "inputData": {
                "vmo": "{{data}}",
                "eventData": "{{parameters.eventData}}"
            },
            "deps": "js/desUpdateLibraryService"
        },
        "getSelectedFileInfoAction": {
            "actionType": "JSFunction",
            "method": "getLibraryFileInfo",
            "inputData": {
                "fileName": "{{parameters.fileName}}",
                "fileNameNoExt": "{{parameters.fileNameNoExt}}",
                "fileExt": "{{parameters.fileExt}}",
                "formData": "{{parameters.formData}}",
                "data": "{{data}}"
            },
            "outputData": {
                "dataToBeRelated": "dataToBeRelated",
                "fileInputForms": "fileInputForms"
            },
            "deps": "js/desUpdateLibraryService"
        },
        "publishToACCEventBus": {
            "actionType": "JSFunction",
            "method": "publish",
            "inputData": {
                "eventId": "{{parameters.eventName}}",
                "eventData": "{{parameters.eventData}}"
            },
            "deps": "js/accEventBus"
        }
    },
    "onEvent": [
        {
            "eventId": "getLibrarySuccess",
            "action": "updateSelectedLibraryDetails",
            "inputArgs": {
                "eventName": "getLibrarySuccess",
                "eventData": "{{eventData.eventData}}"
            }
        },
        {
            "eventId": "getLibraryFailure",
            "action": "publishToACCEventBus",
            "inputArgs": {
                "eventName": "getLibraryFailure",
                "eventData": "{{eventData.eventData}}"
            }
        }
    ],
    "i18n": {
        "propertiesCaption": [
            "DesLibraryMessages"
        ],
        "nameDisplayName": [
            "DesLibraryMessages"
        ],
        "descriptionDisplayName": [
            "DesLibraryMessages"
        ]
    },
    "_viewModelId": "DesLibraryProperties",
    "_uniqueViewModelId": "DesLibraryProperties",
    "ctx": {}
};

    /*
    <aw-panel-section caption="i18n.propertiesCaption" collapsed="false">
    <aw-widget prop="data.name"></aw-widget>
    <aw-widget prop="data.description"></aw-widget>
</aw-panel-section>

    */
    const renderFn =(props)=> {
        let subPanelContext = props.subPanelContext ;
        let { viewModel: { data, dataProviders, dispatch, conditions, selectionModels, editHandlers, chartProviders, ports  }, grids, ctx, actions, fields, messages, i18n, formProp, viewPath  } = props;
        data = {...data, dataProviders};
        if( subPanelContext && subPanelContext.fields ){
            fields = { ...fields, ...subPanelContext.fields };
        }
        let $index = null;
        return (
                <AwPanelSection caption={i18n.propertiesCaption} collapsed="false">
        <AwWidget {...getField("data.name", fields, $index, null, null )}>
        </AwWidget>
        <AwWidget {...getField("data.description", fields, $index, null, null )}>
        </AwWidget>
    </AwPanelSection>
        )
    };


    /*
    define component
    */
    const Component = createComponent( declViewModelJson, renderFn, undefined, ctxImportObj );

    export default Component;